module.exports = __webpack_public_path__ + "img/urban-sound-laptop.4c481b7b.jpg";